import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Team, TeamPurchaseOrderPhase, TeamSalesOrderPhase } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0260. チーム発注フェーズ一覧
 * [GET] /workspaces/:identifier/teams/:team_id/team_purchase_order_phases
 */
type Props = {
  identifier: string;
  team_id: number;
  no_cache?: boolean;
};
const teamPurchaseOrderPhases = (props: Props): Promise<TeamPurchaseOrderPhase[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/team_purchase_order_phases`, {
    params: props,
  });
};

export const useTeamPurchaseOrderPhases = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'team_purchase_order_phases'],
    queryFn: () => teamPurchaseOrderPhases(props),
  });
};

export const useTeamPurchaseOrderPhasesNoCache = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'team_purchase_order_phases'],
    queryFn: () => teamPurchaseOrderPhases(props),
    staleTime: props.no_cache ? 10 : Number(process.env.REACT_APP_API_STALE_TIME),
  });
};

export const useInvalidateTeamPurchaseOrderPhases = (props: Props) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'team_purchase_order_phases'],
    });
  };

  return { invalidate };
};
